export interface ExperienceEntry {
  id: string;
  company: string;
  title: string;
  link: string;
  startYear: string;
  endYear?: string; // omitted = current role
  chips: string[];
}

export const experience: ExperienceEntry[] = [
   {
    id: "mentes-service",
    company: "Mentes Service",
    title: "Front-End Developer",
    link: "https://mentesservice.com/",
    startYear: "2025",
    chips: ["TypeScript", "React", "Micro-Frontend"],
  },
  {
    id: "accenture",
    company: "Accenture",
    title: "Front-End Developer",
    link: "https://www.accenture.com/it-it",
    startYear: "2022",
    endYear: "2025",
    chips: ["TypeScript", "React", "Svelte", "Lit", "Redux"],
  },
  {
    id: "object-method",
    company: "Object Method",
    title: "Front-End Developer",
    link: "http://www.objectmethod.it/",
    startYear: "2022",
    endYear: "2022",
    chips: ["React", "JavaScript", "Java"],
  },
  {
    id: "sognando-casa",
    company: "Sognando Casa",
    title: "Front-End Developer",
    link: "https://sognando.casa/it",
    startYear: "2021",
    endYear: "2021",
    chips: ["jQuery", "JavaScript", "PHP"],
  },
];
